import { render, staticRenderFns } from "./fenzu.vue?vue&type=template&id=50ee91ea&"
import script from "./fenzu.vue?vue&type=script&lang=ts&"
export * from "./fenzu.vue?vue&type=script&lang=ts&"
import style0 from "./fenzu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports